// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2OMrR","signatureBlock":"Footer_signatureBlock__3lW3W","signature":"Footer_signature__2AizN"};